import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from '../../environments/environment';

(window as any).Pusher = Pusher;

@Injectable({ providedIn: 'root' })
export class EchoService {
  private echo: any = null;

  headers(): HttpHeaders {
    return new HttpHeaders({ Authorization: 'Bearer ' + localStorage.getItem('access_token') });
  }

  connect(): any {
    if (this.echo) return this.echo;
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: environment.reverbKey,
      cluster: 'mt1',
      wsHost: environment.reverbHost,
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      authEndpoint: environment.apiUrl + 'broadcasting/auth',
      auth: { headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') } },
    });
    return this.echo;
  }

  disconnect() {
    if (this.echo) { this.echo.disconnect(); this.echo = null; }
  }
}